import {observable, action} from 'mobx';

export default class SubmitterModel {
	
	@observable isEmployee = false;
	
	@observable firstName = null;

	@observable lastName = null;

	@observable position = null;

	@observable company = null;

	@observable email = null;

	@observable contactNumber = null;

	/**
	 * Set the isEmployee id
	 * @param {?boolean} value - The isEmployee id
	 */
	@action setisEmployee(value) {
		this.isEmployee = value || false;
	}

	/**
	 * Set the firstName type
	 * @param {string} value - The firstName type
	 */
	@action setfirstNamer(value) {
		this.firstName = value || null;
	}

	/**
	 * Set the lastName
	 * @param {?string} value - The lastName
	 */
	@action setlastName(value) {
		this.lastName = value || null;
	}

	/**
	 * Set the position
	 * @param {?string} value - The position
	 */
	@action setposition(value) {
		this.position = value || null;
	}

	/**
	 * Set the company name
	 * @param {?string} value - The company name
	 */
	@action setcompany(value) {
		this.company = value || null;
	}

	/**
	 * Set the email
	 * @param {?string} value - The email
	 */
	@action setemail(value) {
		this.email = value || null;
	}

	/**
	 * Set the contactNumber
	 * @param {?string} value - The contactNumber
	 */
	@action setcontactNumber(value) {
		this.contactNumber = value || null;
	}
}

export class SubmitterFactory {
	/**
	 * Create an Wage from a plain old object
	 * @param submitter
	 * @returns {?SubmitterModel}
	 */
	static createFromService(submitter) {
		if (!submitter) {
			return null;
		}
		const submitterModel = new SubmitterModel();
		submitterModel.setisEmployee(submitter.submitterType);
		submitterModel.setfirstNamer(submitter.firstName);
		submitterModel.setlastName(submitter.lastName);
		submitterModel.setposition(submitter.position);
		submitterModel.setcompany(submitter.companyName);
		submitterModel.setemail(submitter.emailAddress);
		submitterModel.setcontactNumber(submitter.contactNumber);
		return submitterModel;
	}
}
